import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SEO } from './shared/seo/seo-data';

export const ROUTES: Routes = [
  {
    path: '',
    data: { seo: SEO.home },
    component: HomeComponent,
  },
  { path: 'home', pathMatch: 'full', redirectTo: '' },
  {
    path: 'angebot',
    data: { seo: SEO.offer },
    loadComponent: () => import('./offer/offer.component').then(module_ => module_.OfferComponent),
  },
  {
    path: 'buchung',
    data: { seo: SEO.booking },
    loadComponent: () => import('./booking/booking.component').then(module_ => module_.BookingComponent),
  },
  {
    path: 'ueber-uns',
    data: { seo: SEO.about },
    loadComponent: () => import('./about/about.component').then(module_ => module_.AboutComponent),
  },
  {
    path: 'kontakt',
    data: { seo: SEO.contact },
    loadComponent: () => import('./contact/contact.component').then(module_ => module_.ContactComponent),
  },
  {
    path: 'impressum',
    data: { seo: SEO.imprint },
    loadComponent: () => import('./imprint/imprint.component').then(module_ => module_.ImprintComponent),
  },
  {
    path: 'agb',
    data: { seo: SEO.agb },
    loadComponent: () => import('./agb/agb.component').then(module_ => module_.AgbComponent),
  },
  { path: '**', redirectTo: '' },
];
